import { render, staticRenderFns } from "./NotificationElement.vue?vue&type=template&id=3be69a67&scoped=true&"
import script from "./NotificationElement.vue?vue&type=script&lang=js&"
export * from "./NotificationElement.vue?vue&type=script&lang=js&"
import style0 from "./NotificationElement.vue?vue&type=style&index=0&id=3be69a67&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be69a67",
  null
  
)

export default component.exports